import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Grid, Row, Col } from "@vds/grids";
import { TextLink } from "@vds/buttons";
import { MarginSpacerM, MarginSpacerL, MarginSpacerS } from "../styleTag";
import "./GWjointOfferCard.css"
import { isMobile } from "react-device-detect";
import { DeviceContainer } from "./styles";
import JointOfferCardModalNew from "./JointOfferCardModalNew";


export const getImageUrl = (url) => {
  if (!(typeof url === "string" && url?.length)) {
    return "";
  } else if (url.charAt(0) === "/") {
    return `${window?.mbtGlobal?.assetsBaseUrl}${url}`;
  } else {
    return url;
  }
};
const JointOfferCardNew = ({ aem, aemContent, aemContentModal, promoType, ...props }) => {
  const [additionalURL, handleAdditionalURL] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (String(props.type).includes("non-smartPhone")) {
      const addURL = String(props.category)?.toLowerCase().split(" ");
      const resultURL =
        addURL.length > 1 ? addURL[0] + "-" + addURL[1] : addURL[0];
      handleAdditionalURL(resultURL + "/byod");
    }
  }, [props.category]);

  return (
    <>
      <CustomDeviceContainer className="device-card-gwoffer">
          
          <DeviceDetailsContainer className="device-container">
            <Grid colGutter={false} rowGutter={0}>
            
              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  <div className="Bundle-Title">
                    {!!aemContent?.headerText && (
                      <Title size="medium" color="#FFFFFF" bold>
                        {aemContent?.headerText}
                      </Title>
                    )}
                  </div>
                  
                </Col>
              </Row>

              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                {/* {isMobile ? <MarginSpacerS /> : <MarginSpacerM />} */}
                  <TextOnImage size="medium" color="yellow" bold>
                    {aemContent?.badgeTxt}
                  </TextOnImage>
                  {isMobile ? <MarginSpacerS /> : <MarginSpacerM />}
                  {/* <MarginSpacerXS /> */}
                </Col>
              </Row>

              <Row>
                {isMobile ? <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {!!aemContent?.content && (
                    <Body size="small" color="#FFFFFF">
                      {aemContent?.content}
                    </Body>
                    
                      
                  )}
                </Col> : 
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {!!aemContent?.content && (
                    <Body size="large" color="#FFFFFF">
                      {aemContent?.content}
                    </Body>
                    
                      
                  )}
                </Col>}
              </Row>

              <Row>
                <Col>
                  {isMobile ? <MarginSpacerS /> : <MarginSpacerL />}
                  {!!aemContent?.subHeaderTextLink && (
                    <StyledTextLink className="text-link"
                      size="small"
                      color="#FFFFFF"
                      onClick={(e) => {
                        e.stopPropagation()
                        setShowModal(true)
                      }}

                    >{aemContent?.subHeaderTextLink}
                    </StyledTextLink>
                  )}
                  <MarginSpacerL/>
                </Col>
              </Row>
            </Grid>
          </DeviceDetailsContainer>
        {/* </a> */}
      </CustomDeviceContainer>
      {showModal && <JointOfferCardModalNew setShowModal={setShowModal} showModal={showModal} aemContent={aemContentModal} />}
    </>
  );
};



const TextOnImage = styled(Title)`
  display: flex;
  margin-top: 5px
  font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 28px;
`;

const StyledTextLink = styled(TextLink)`
padding-right: 0px !important;
color:white !important;
white-space: nowrap;
.text-link : hover{
  color:white !important;
}
`;

const CustomDeviceContainer = styled(DeviceContainer)`
height:269px;
width:100%;
box-sizing: border-box;
@media screen only and (max-width:768px){
padding:7px;
height: 253px;
display: flex;
margin-top:0px !important
};
@media screen only and (max-width:379px){
  padding: 7px 0 0 0
  height: 1px
  }
`

const DeviceDetailsContainer = styled.div`
position:relative;
@media screen only and (max-width: 767px){
  position:relative;
  bottom: 15px;
  margin-top: 0px
} 
`

export default JointOfferCardNew;
